module.exports = __webpack_public_path__ + "img/cpany11.6e172279.png";